import React from "react";

export const LOGO_SRC = "/logo.png";
export const LOGO_WEBP = "/logo.webp";
export const LOGO_ALT = "Her Salty Studio";
export const NAV_BRAND_TITLE = "HER SALTY STUDIO";

const SIZES = {
  nav: 58,
  footer: 132,
  modal: 96,
};

export default function SiteLogo({ variant = "nav", className = "", ...props }) {
  const size = SIZES[variant] ?? SIZES.nav;
  const classes = ["site-logo", variant && `site-logo--${variant}`, className]
    .filter(Boolean)
    .join(" ");

  return (
    <picture>
      <source srcSet={LOGO_WEBP} type="image/webp" />
      <img
        src={LOGO_SRC}
        alt={LOGO_ALT}
        className={classes}
        width={size}
        height={size}
        decoding="async"
        {...props}
      />
    </picture>
  );
}
